export default __webpack_public_path__ + "static/media/warning-notification.1ca1ea72.svg";